import { Injectable } from '@angular/core';
import { NetworkManager } from 'src/app/managers/network/network.manager';
import { HttpHeaders } from '@angular/common/http';
import { RequestField } from 'src/app/enums/network/request/requestField.enum';
import { CQWebappApi } from 'src/app/enums/network/request/cqwebapp/cqwebappApi.enum';

@Injectable({
  providedIn: 'root',
})
export class ProgressRequest {
  constructor(private network: NetworkManager) {}

  /**
   *
   * @param token
   * @param siteId
   */
  get(token: string, siteId: number) {
    let url = this.network.CodaQApi() + CQWebappApi.GET_PROGRESS_MODE;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    const form = new URLSearchParams();
    form.set(RequestField.SITE_ID, siteId.toString());

    return this.network.http().put(url, form.toString(), { headers });
  }

  /**
   *
   * @param token
   * @param siteId
   * @param callModeId
   */
  update(token: string, siteId: number, callModeId: number) {
    let url = this.network.CodaQApi() + CQWebappApi.UPDATE_PROGRESS_MODE;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    const form = new URLSearchParams();
    form.set(RequestField.SITE_ID, siteId.toString());
    form.set(RequestField.CALLMODE_ID, callModeId.toString());

    return this.network.http().put(url, form.toString(), { headers });
  }
}
